import { deepClone } from '@/helper/lodashHelper';

const remapPartnerArea = (type, items = []) =>
  items.map(({ alias, fields = [] }) => {
    const mappedFields =
      fields[0] &&
      fields[0].map((field) => ({
        ...field,
        type: field.wxtype,
        subType: field.parvw,
      }));

    const isContact = type === 'contact';
    const contentType = (isContact && 'organisationList') || 'threeSixtyView';

    return {
      alias,
      contentType,
      fields: mappedFields,
    };
  });

export default {
  SET_SCHEMA(state, schema) {
    state.schema = schema;
  },
  SET_OBJECT(state, object) {
    state.object = deepClone(object);
  },
  SET_EDIT_OBJECT(state, object) {
    state.editObject = deepClone(object);
    state.editMode = !!object.EDITMODE;
  },
  SET_EDIT_INFORMATION(state, information) {
    state.editInformation = { ...state.editInformation, ...information };
  },
  RESET_EDIT_INFORMATION(state) {
    state.editInformation = {};
  },
  SET_OVERVIEW_BAR(state, overviewBar = []) {
    state.overviewBar = overviewBar;
  },
  SET_TYPE(state, type) {
    state.type = type;
  },
  SET_INIT_OBJECT(state, object) {
    state.initObject = object;
  },
  // TODO: BE should provide same structure here as for searchAutosuggest
  SET_SUGGESTIONS(state, suggestions = []) {
    state.suggestions = suggestions.map((suggestion) => ({
      fieldBind: suggestion.FIELDNAME,
      recordBind: suggestion.RECORD,
      numChars: suggestion.NUM_CHARS,
      inputMap: suggestion.INPUT_MAP,
      output: suggestion.output,
      freeText: suggestion.freeText,
      multi: suggestion.multi,
      targets: suggestion.targets,
    }));
  },
  SET_SUGGESTIONS_PARTNERS(state, partners) {
    state.suggestionsPartners = partners;
  },
  SET_SUGGESTIONS_PARTNER(state, partner) {
    const clone = state.suggestionsPartners
      ? [...state.suggestionsPartners]
      : [];
    const { value } = partner;

    state.suggestionsPartners = clone.map((partner_) => {
      if (partner_[Object.keys(partner_)[0]] === value)
        return { ...partner_, ...partner };

      return partner_;
    });
  },
  SET_TITLE_PATTERN(state, titlePattern) {
    state.titlePattern = titlePattern;
  },
  SET_TILE_PATTERN(state, tilePattern) {
    state.tilePattern = tilePattern;
  },
  SET_TILE_FIELDS(state, tileFields = []) {
    state.tileFields = tileFields;
  },
  SET_AREA_PATTERN(state, areaPattern) {
    state.areaPattern = areaPattern || [];
    state.availableAreas = state.areaPattern.map(({ areaType }) => areaType);
  },
  SET_AREA_FIELDS(state, areaFields) {
    if (areaFields) {
      state.areaFields = areaFields;
    }
  },
  SET_GROUPING(state, grouping) {
    state.grouping = grouping;
  },
  SET_LISTS(state, lists = []) {
    state.lists = lists;
  },
  SET_VIEW_AREAS(state, viewAreas) {
    const mappedViewAreas = {};

    viewAreas &&
      Object.entries(viewAreas).forEach(([key, items]) => {
        const isPartnerArea = key.includes('DetailPartners');
        mappedViewAreas[key] = isPartnerArea
          ? remapPartnerArea(state.type, items)
          : items;
      });

    if (state.type === 'email') {
      // Todo: this should come from metadata
      mappedViewAreas.vaMailDetailAttachments = [
        {
          alias: 'WX_GENERAL_ATTACHMENTS',
          contentType: 'attachments',
          fields: [],
        },
      ];
    }

    state.viewAreas = mappedViewAreas;
  },
  SET_KEY_FIELDS(state, keyFields) {
    state.keyFields = keyFields;
  },
  SET_SEARCH_CRITERIA(state, searchCriteria) {
    state.searchCriteria = searchCriteria;
  },
  SET_SEARCH_LISTS(state, searchLists) {
    state.searchLists = searchLists;
  },
  SET_SEARCH_AUTO_SUGGEST(state, searchAutoSuggest = []) {
    state.searchAutoSuggest = searchAutoSuggest;
  },
  SET_LIST_PAGE_SIZE(state, listPageSize) {
    state.listPageSize = listPageSize;
  },
  SET_SETTINGS(state, settings) {
    state.settings = settings;
  },
  SET_GLOBAL_SEARCH(state, searchInfo) {
    state.globalSearch = searchInfo;
  },
  SET_TEXTS(state, texts) {
    state.texts = texts;
  },
  SET_ATTACHMENTS(state, attachments) {
    state.attachments = attachments;
  },
  SET_EXP_SEARCH(state, expSearch) {
    state.expSearch = expSearch;
  },
  SET_PROGRESS_BAR(state, progressBar) {
    state.progressBar = progressBar;
  },
};
